var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOffersViewed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36.2347,
    height: 35.6206,
    rx: 5.52733,
    fill: "url(#paint0_linear_1265_7570)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4434 25.1692V23.5315C10.4434 22.6628 10.7885 21.8297 11.4027 21.2154C12.017 20.6011 12.8501 20.2561 13.7188 20.2561H16.9943C17.863 20.2561 18.6961 20.6011 19.3104 21.2154C19.9246 21.8297 20.2697 22.6628 20.2697 23.5315V25.1692M21.0886 10.5361C21.7932 10.7165 22.4176 11.1263 22.8636 11.7008C23.3095 12.2753 23.5516 12.9819 23.5516 13.7092C23.5516 14.4365 23.3095 15.1431 22.8636 15.7177C22.4176 16.2922 21.7932 16.7019 21.0886 16.8823M25.1829 25.1692V23.5315C25.1788 22.8086 24.9355 22.1073 24.4912 21.5371C24.0468 20.9668 23.4263 20.5596 22.7263 20.3789M12.0811 13.7051C12.0811 14.5738 12.4262 15.407 13.0404 16.0212C13.6547 16.6355 14.4878 16.9806 15.3565 16.9806C16.2252 16.9806 17.0584 16.6355 17.6726 16.0212C18.2869 15.407 18.632 14.5738 18.632 13.7051C18.632 12.8364 18.2869 12.0033 17.6726 11.389C17.0584 10.7748 16.2252 10.4297 15.3565 10.4297C14.4878 10.4297 13.6547 10.7748 13.0404 11.389C12.4262 12.0033 12.0811 12.8364 12.0811 13.7051Z",
    stroke: "white",
    strokeWidth: 1.2283,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1265_7570",
    x1: 18.1174,
    y1: 0,
    x2: 18.1174,
    y2: 35.6206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54B27C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#186639"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffersViewed);
export default __webpack_public_path__ + "static/media/Offers Viewed.a74b3015050ae98a0bc52f989f8df808.svg";
export { ForwardRef as ReactComponent };